module.exports = __webpack_public_path__ + "static/promidon-logo-dark-598e89e335bffd67431684222bfb1876.svg";